import { FILE_TYPES } from 'constant/variables';
import React, { useState } from 'react';
import FileViewer from "react-file-viewer";
import { Modal, ModalHeader} from 'reactstrap';

const icons = {
    [FILE_TYPES.PDF]: require("../../assets/svg/pdf.svg"),
    [FILE_TYPES.EXCEL]: require("../../assets/svg/excel.svg"),
    [FILE_TYPES.VIDEO]: require("../../assets/svg/video.svg"),
  }

const userIcons = {
    [FILE_TYPES.PDF]: require("../../assets/images/pdf-user.png"),
    [FILE_TYPES.EXCEL]: require("../../assets/images/excel-user.png"),
    [FILE_TYPES.VIDEO]: require("../../assets/images/video-user.png"),
  }

function FileViewerModel({file_type, file_link, subject, isAdmin}) {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const isVideo = file_type == FILE_TYPES.VIDEO;

  const fileType = file_type == FILE_TYPES.PDF ? 'pdf' : file_type == FILE_TYPES.EXCEL ? 'xlsx' : 'mp4';

  if(!file_link) return null;
  return (
    <div>
      <div onClick={() => setModal(true)} className="cursor-pointer">
        <img src={isAdmin ? icons[file_type] : userIcons[file_type]} style={{ width: 60, borderRadius: '1%' }} />
      </div>
      <Modal size='lg' isOpen={modal} centered >
        <ModalHeader toggle={toggle}>{subject}</ModalHeader>
        <div style={{height: isVideo ? undefined : 450}}>
       {file_type == FILE_TYPES.VIDEO ? <video width="100%" controls>
            <source src={file_link} type="video/mp4" />
            </video> : <FileViewer fileType={fileType} filePath={file_link} onError={(error) => {console.log("File Viewwer error", error)}} />}
        </div>
      </Modal>
    </div>
  );
}

export default FileViewerModel;